<template>
  <section>
    <div class="role">
      <div class="roleRight" style="border-left: 0">
        <div class="roleRight_Top">
          <el-input
              size="mini"
              clearable
              v-model="search.keyword"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchRoleList"
          ></el-input>
          <el-select size="mini" v-model="search.status" clearable placeholder="请选择">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
          <el-button size="mini" type="primary" @click="SearchRoleList"
          >查询
          </el-button
          >
          <el-button
              size="mini"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
              row-key="roleId"
              v-loading="loading"
          >
            <el-table-column
                fixed
                label="序号"
                prop="roleId"
                type="index"
                width="80"
            >
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" width="140">
            </el-table-column>
            <el-table-column prop="address" label="服务器地址" width="140">
            </el-table-column>
            <el-table-column prop="port" label="端口" width="80">
            </el-table-column>
            <el-table-column prop="account" label="服务账号" min-width="200">
            </el-table-column>
            <el-table-column prop="fromAddress" label="发件地址" min-width="200">
            </el-table-column>
            <el-table-column prop="replyToAddress" label="回复地址" min-width="200">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="80">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                    @change="handleStatusSwitch(scope.row.id)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                    @click="handleClick('edit', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button
                >
                <el-button
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑STMP设置"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="750px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >
          <el-form-item label="邮件名称：" prop="name">
            <el-input
                clearable
                placeholder="请填写邮件名称"
                v-model="params.name"
            ></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="服务账号：" prop="account">
                <el-input
                    clearable
                    placeholder="请填写服务账号"
                    v-model="params.account"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务地址：" prop="address">
                <el-input
                    clearable
                    placeholder="请填写服务地址"
                    v-model="params.address"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务密码：" prop="password">
                <el-input
                    clearable
                    placeholder="请填写服务密码"
                    v-model="params.password"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务端口：" prop="port">
                <el-input
                    clearable
                    placeholder="请填写服务端口"
                    v-model="params.port"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="回复地址：" prop="replyToAddress">
                <el-input
                    clearable
                    placeholder="请填写回复地址"
                    v-model="params.replyToAddress"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="	发件地址：" prop="fromAddress">
                <el-input
                    clearable
                    placeholder="请填写发件地址"
                    v-model="params.fromAddress"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>

import upLoadImg from "@views/international/components/upLoadImg";
import uploadCommonImg from "@comp/uploadCommonImg";
import richText from "@comp/richText";

export default {
  components: {upLoadImg, uploadCommonImg, richText},
  data() {
    return {
      loading: false,
      search: {},
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [{required: true, message: "请填写名称", trigger: "blur"}],
        account: [{required: true, message: "请填写服务账号", trigger: "blur"}],
        address: [{required: true, message: "请填写服务地址", trigger: "blur"}],
        password: [{required: true, message: "请填写服务密码", trigger: "blur"}],
        port: [{required: true, message: "请填写服务端口", trigger: "blur"}],
        replyToAddress: [{required: true, message: "请填写回复地址", trigger: "blur"}],
        fromAddress: [{required: true, message: "请填写发件地址", trigger: "blur"}],
      }, //表单验证提示
      tableData: [], //二级--角色列表，
      dialogVisible: false,
      languageList: [],
      currencyList: [],
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  created() {
    this.getCountryList();
  },
  methods: {
    SearchRoleList() {
      this.getCountryList()
    },
    async getCountryList() {
      this.loading = true;
      //角色列表
      const {data: res} = await this.$post(
          `/email/config/list`, {...this.search},
      );
      this.loading = false;
      this.tableData = res.data;
    },
    //switch状态改变 --接口 修改角色状态
    handleStatusSwitch(id) {
      this.$get(`/email/config/change/${id}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
          this.getCountryList()
        }
      });
    },
    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "addNext") {
        //编辑
        this.params = {};

      } else if (type == "edit") {
        //修改  change
        this.params = JSON.parse(JSON.stringify(row));
        this.getCountryInfo()
      }
    },
    async getCountryInfo() {
      const {data: resData} = await this.$post(
          `/email/config/info/${this.params.id}`,{},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (resData.result != 200) return;
      this.params = resData.data
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$post("/email/config/edit", this.params, {
            headers: {
              isLoading: true,
            },
          });
          if (resData.result != 200) return;
          this.getCountryList();
          this.dialogVisible = false
          this.$message.success("添加成功!");
        });
      });
    },
    //删除
    async del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$post(
            `/email/config/remove/${row.id}`,{},
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getCountryList();
        this.$message.success("删除成功!");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  .fa-line {
    display: block;
    border-right: 1px solid #ccc;
  }

  &Left {
    padding-right: 15px;
    width: auto;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 20px;
    }
  }

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    padding-left: 15px;
    border-left: 1px solid #ccc;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>
